// Mock data for Vedankur Ayurveda website

export const heroData = {
  headline: "Authentic Healing for the Modern Soul",
  subheadline: "Expert Ayurvedic care by Dr. Kirti & Dr. Sameer, dedicated to restoring your natural balance.",
  heroImage: "https://images.unsplash.com/photo-1488345979593-09db0f85545f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHx3ZWxsbmVzcyUyMHNwYXxlbnwwfHx8fDE3NzUyODczOTd8MA&ixlib=rb-4.1.0&q=85"
};

export const doctors = [
  {
    name: "Dr. Kirti Khamkar-Diwate",
    specialization: "Specialist in PCOD, Infertility & Handmade Ayurvedic Products",
    experience: "Expert in Women's Health & Wellness",
    image: "https://images.unsplash.com/photo-1667904498869-933d459ddb1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxheXVydmVkaWMlMjBoZXJic3xlbnwwfHx8fDE3NzUyODczOTN8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Dr. Sameer Jondhale",
    specialization: "MD Ayurveda",
    experience: "20+ Years of Clinical Excellence",
    image: "https://images.unsplash.com/photo-1730977806288-96b82f795008?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxheXVydmVkaWMlMjBoZXJic3xlbnwwfHx8fDE3NzUyODczOTN8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const services = [
  {
    id: 1,
    title: "PCOD & Infertility Treatment",
    description: "Specialized care for women's health issues with natural Ayurvedic treatments that address root causes and restore hormonal balance.",
    icon: "Flower2",
    image: "https://images.pexels.com/photos/7615621/pexels-photo-7615621.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    title: "Suvarn Prashan & Child Immunity",
    description: "Ancient immunity-boosting protocol for children. Strengthen your child's natural defenses through time-tested Ayurvedic practices.",
    icon: "Baby",
    image: "https://images.pexels.com/photos/6978215/pexels-photo-6978215.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Lifestyle Disorder Management",
    description: "Comprehensive treatment for diabetes, obesity, and modern lifestyle conditions through personalized Ayurvedic protocols.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHx3ZWxsbmVzcyUyMHNwYXxlbnwwfHx8fDE3NzUyODczOTd8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Vedankur Handmade Products",
    description: "Premium handmade Ayurvedic soaps and wellness products crafted with authentic herbs and traditional wisdom.",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1760696473939-88db0835c908?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxheXVydmVkaWMlMjBoZXJic3xlbnwwfHx8fDE3NzUyODczOTN8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    condition: "PCOD Treatment",
    text: "After struggling with PCOD for years, Dr. Kirti's personalized treatment plan transformed my health. I'm now symptom-free and feeling better than ever.",
    rating: 5
  },
  {
    id: 2,
    name: "Rahul Deshmukh",
    condition: "Lifestyle Management",
    text: "Dr. Sameer's holistic approach helped me manage my diabetes naturally. His guidance and treatment have been life-changing.",
    rating: 5
  },
  {
    id: 3,
    name: "Anjali Patil",
    condition: "Child Immunity",
    text: "Suvarn Prashan has significantly improved my daughter's immunity. She's healthier and happier. Thank you, Vedankur team!",
    rating: 5
  }
];

export const vedankurDifference = {
  title: "The Vedankur Difference",
  subtitle: "From Ancient Wisdom to Modern Healing",
  description: "Bridging the timeless teachings of Maharshi Charak with contemporary clinical precision. Our approach combines centuries-old Ayurvedic wisdom with modern diagnostic methods to deliver authentic, effective healing.",
  highlights: [
    {
      icon: "Youtube",
      title: "Educational Excellence",
      description: "Empowering patients through knowledge with our active YouTube presence and health education initiatives."
    },
    {
      icon: "Tv",
      title: "60+ TV Appearances",
      description: "Recognized experts sharing Ayurvedic wisdom on leading health and wellness television programs."
    },
    {
      icon: "Award",
      title: "Clinical Excellence",
      description: "Combining 20+ years of experience with authentic Ayurvedic protocols for proven results."
    },
    {
      icon: "Leaf",
      title: "Handcrafted Products",
      description: "Premium, handmade Ayurvedic formulations created in-house with pure, natural ingredients."
    }
  ]
};

export const contactInfo = {
  phone: "+91 8329021070",
  whatsapp: "+918329021070",
  drSameerPhone: "+91 8669187380",
  email: "ayurvedvedankur@gmail.com",
  address: "Vedankur Ayurved, In front of Hotel New Wood, Walhekarwadi, Chinchwad",
  location: {
    lat: 18.632965267889652,
    lng: 73.76892666316849,
    mapUrl: "https://www.google.com/maps?q=18.632965267889652,73.76892666316849"
  },
  hours: "Mon - Sat: 9:00 AM - 7:00 PM",
  youtubeChannel: "https://www.youtube.com/channel/UC8U21z7nW-eKis8rHap5Ftw",
  facebookPage: "https://www.facebook.com/people/Vedankur-Ayurved/100090718726251/",
  linkedinProfile: "https://www.linkedin.com/in/dr-kirti-khamkar-359964122/",
  customGPT: "https://chatgpt.com/g/g-68b1c20b80908191ad221bb4fd10cdf0-aajiicaa-bttvaa"
};
